// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"1c9b22da","396":"4d31c670","522":"1fdc594b","524":"16bb8e5d"}[chunkId] + ".chunk.css";
};